export type ApiServer = 'uralsoccard' | 'transportCard';

export const DEFAULT_API_SERVER: Exclude<ApiServer, 'dobroru'> = 'uralsoccard';

export enum ApiEnvironments {
  prod = 'prod',
  test = 'test',
}

export interface SettingParams {
  baseUrl: Record<ApiServer, string> & {dobroru: string};
}
